<template>
  <section v-loading="isLoading" class="container">
    <breadcrumb v-if="!isMobile" crumb="pole-rf-coefficients" />
    <search-input
      placeholder="Введите КЛАДР места погрузки/выгрузки"
      :value="searchKladr"
      :disabled="isLoading"
      @clear="clearFilter"
      @search="filterCoefficients"
    />
    <el-row class="coeff__title" type="flex" align="middle">
      <el-col v-for="field in fields" :key="field.field" :span="field.width">
        {{ field.label }}
      </el-col>
      <el-col :span="2" />
    </el-row>
    <template v-if="coefficients.length && !isLoading">
      <el-row
        v-for="item in coefficients"
        :key="item.id"
        :gutter="24"
        class="coeff"
        type="flex"
        align="middle"
      >
        <el-col v-for="field in fields" :key="field.field" :span="field.width">
          {{ item[field.field] }}
        </el-col>
        <el-col :span="1">
          <el-button
            type="danger"
            icon="el-icon-edit"
            circle
            @click="showEditModal(item)"
          />
        </el-col>
      </el-row>

      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </template>

    <div v-if="!coefficients.length && !isLoading" class="coeff__empty">
      Данные по КЛАДР отсутствуют
    </div>

    <el-dialog
      v-if="isEditOpen"
      title="Укажите новое значение коэффициента"
      :visible="true"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="60%"
      @close="isEditOpen = false"
    >
      <coefficient-edit-modal
        :coefficient="currentCoefficient"
        @update="updateCoefficient"
        @close="isEditOpen = false"
      />
    </el-dialog>
  </section>
</template>

<script>
import {
  FETCH_POLE_COEFFICIENTS,
  GET_POLE_COEFFICIENTS,
  GET_POLE_COEFFICIENTS_LOADING,
  GET_POLE_COEFFICIENTS_PAGINATION,
  UPDATE_POLE_COEFFICIENT,
} from '@/store/actions/pole'
import { coefficientFields } from '@/views/PoleCoefficients/data/fields'
import { mapActions, mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb.vue'
import CoefficientEditModal from '@/views/PoleCoefficients/components/CoefficientEditModal.vue'
import PaginationCustom from '@/components/Tables/PaginationCustom.vue'
import SearchInput from '@/components/Shared/SearchInput.vue'
export default {
  name: 'PoleCoefficients',
  components: {
    CoefficientEditModal,
    PaginationCustom,
    Breadcrumb,
    SearchInput,
  },
  data() {
    return {
      currentCoefficient: null,
      searchKladr: '',
      isEditOpen: false,
      fields: coefficientFields,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: `pole/${GET_POLE_COEFFICIENTS_LOADING}`,
      coefficients: `pole/${GET_POLE_COEFFICIENTS}`,
      pagination: `pole/${GET_POLE_COEFFICIENTS_PAGINATION}`,
    }),
  },
  mounted() {
    this.fetchCoefficients()
  },
  methods: {
    ...mapActions({
      fetchCoefficients: `pole/${FETCH_POLE_COEFFICIENTS}`,
      saveCoefficient: `pole/${UPDATE_POLE_COEFFICIENT}`,
    }),
    clearFilter() {
      this.searchKladr = ''
      this.fetchCoefficients()
    },
    filterCoefficients(value) {
      this.searchKladr = value
      const params = this.preparedParams()

      this.fetchCoefficients(params)
    },
    changePage(page) {
      console.log(page)
      const params = this.preparedParams(page)

      this.fetchCoefficients(params)
    },
    preparedParams(page = 1) {
      return {
        page,
        'per-page': this.pagination.perPage,
        search: this.searchKladr.length ? this.searchKladr : null,
      }
    },
    showEditModal(coefficient) {
      this.currentCoefficient = coefficient
      this.isEditOpen = true
    },
    updateCoefficient(data) {
      // сохраняем только если были изменения
      if (this.currentCoefficient.price_per_ton !== data.price) {
        const params = this.preparedParams(this.pagination.currentPage)

        this.saveCoefficient({ data, params })
      }
      this.isEditOpen = false
    },
  },
}
</script>
<style lang="sass" scoped>
.coeff__title
  margin-top: 40px
  margin-bottom: 20px
  font-weight: bold

.coeff__empty
  display: flex
  justify-content: center
  margin: 100px 0
  font-size: 18px
  font-weight: bold
  font-style: italic
  color: #606266

.coeff
  min-height: 60px
  padding: 8px 0
  margin-bottom: 16px
  background: #fff
  font-size: 16px

.el-dialog__wrapper ::v-deep .el-dialog__header
    text-align: center
</style>
